import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@/styles/fonts.css'
import '@/styles/style.css'

import { App } from './App'

const page = document.body.dataset.page || 'home'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App page={page} />
  </StrictMode>,
)
